import * as i0 from '@angular/core';
import { Directive, Inject, Input, HostListener, NgModule, EventEmitter, Self, Optional, Output, HostBinding, LOCALE_ID, forwardRef } from '@angular/core';
import { DOCUMENT, CommonModule, getLocaleNumberFormat, NumberFormatStyle } from '@angular/common';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as i1 from '@angular/forms';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { fromEvent, timer, concat, of } from 'rxjs';
import { debounceTime, takeWhile, switchMapTo } from 'rxjs/operators';
import * as i1$1 from '@eui/core';
import Cleave from 'cleave.js';

class UxScrollHandlerDirective {
    constructor(document) {
        this.document = document;
        this._uxScrollHandler = false;
        this.navIsFixed = false;
        this.appHeaderHeight = 0;
    }
    get uxScrollHandler() { return this._uxScrollHandler; }
    set uxScrollHandler(value) { this._uxScrollHandler = coerceBooleanProperty(value); }
    ngOnInit() {
        this.appWrapper = this.document.getElementById('app-wrapper');
        this.appHeader = this.document.getElementById('app-header');
        if (this.appHeader) {
            this.appHeaderHeight = this.appHeader.scrollHeight;
        }
    }
    onWindowScroll() {
        if (this.uxScrollHandler && this.appHeaderHeight !== 0) {
            let number = this.document.body.scrollTop || this.document.documentElement.scrollTop; // Chrome || IE/FF
            if (number > this.appHeaderHeight) {
                this.navIsFixed = true;
                this.appWrapper.classList.add('shrink-header-active');
            }
            else if (this.navIsFixed && number < this.appHeaderHeight) {
                this.navIsFixed = false;
                this.appWrapper.classList.remove('shrink-header-active');
            }
        }
    }
}
/** @nocollapse */ UxScrollHandlerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxScrollHandlerDirective, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ UxScrollHandlerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: UxScrollHandlerDirective, selector: "[uxScrollHandler]", inputs: { uxScrollHandler: "uxScrollHandler" }, host: { listeners: { "window:scroll": "onWindowScroll()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxScrollHandlerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[uxScrollHandler]'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { uxScrollHandler: [{
                type: Input
            }], onWindowScroll: [{
                type: HostListener,
                args: ['window:scroll', []]
            }] } });
class UxScrollHandlerElementDirective {
    constructor(document) {
        this.document = document;
        this.navIsFixed = false;
    }
    onWindowScroll() {
        let element = this.document.getElementById(this.uxScrollHandlerElement);
        let number = this.document.body.scrollTop || this.document.documentElement.scrollTop; // Chrome || IE/FF
        if (number > this.toggleActiveHeight) {
            this.navIsFixed = true;
            element.classList.add(this.toggleClass);
        }
        else if (this.navIsFixed && number < this.toggleActiveHeight) {
            this.navIsFixed = false;
            element.classList.remove(this.toggleClass);
        }
    }
}
/** @nocollapse */ UxScrollHandlerElementDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxScrollHandlerElementDirective, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ UxScrollHandlerElementDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: UxScrollHandlerElementDirective, selector: "[uxScrollHandlerElement]", inputs: { uxScrollHandlerElement: "uxScrollHandlerElement", toggleClass: "toggleClass", toggleActiveHeight: "toggleActiveHeight" }, host: { listeners: { "window:scroll": "onWindowScroll()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxScrollHandlerElementDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[uxScrollHandlerElement]'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { uxScrollHandlerElement: [{
                type: Input
            }], toggleClass: [{
                type: Input
            }], toggleActiveHeight: [{
                type: Input
            }], onWindowScroll: [{
                type: HostListener,
                args: ['window:scroll', []]
            }] } });
class UxScrollHandlerDirectiveModule {
}
/** @nocollapse */ UxScrollHandlerDirectiveModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxScrollHandlerDirectiveModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxScrollHandlerDirectiveModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxScrollHandlerDirectiveModule, declarations: [UxScrollHandlerDirective, UxScrollHandlerElementDirective], imports: [CommonModule], exports: [UxScrollHandlerDirective, UxScrollHandlerElementDirective] });
/** @nocollapse */ UxScrollHandlerDirectiveModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxScrollHandlerDirectiveModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxScrollHandlerDirectiveModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [UxScrollHandlerDirective, UxScrollHandlerElementDirective],
                    declarations: [UxScrollHandlerDirective, UxScrollHandlerElementDirective]
                }]
        }] });

/* eslint-disable */
class UxMaxlengthDirective {
    constructor(el, control, renderer) {
        this.el = el;
        this.control = control;
        this.renderer = renderer;
        this.isShowMaxlengthCounter = true;
        this.validityChange = new EventEmitter();
    }
    ngOnDestroy() {
        // remove all DOM added elements
        this.destroyMaxLengthBox();
        // unsubscribe from valueChanges
        if (this.valueChangesSubscription) {
            this.valueChangesSubscription.unsubscribe();
        }
    }
    ngOnChanges(changes) {
        if (changes['isShowMaxlengthCounter'] && this.maxLengthSpan) {
            if (this.isShowMaxlengthCounter) {
                this.createMaxLengthBox();
                this._refreshValue();
            }
            else {
                this.destroyMaxLengthBox();
            }
        }
        if (changes['length']) {
            if (this.length < 0) {
                throw new Error('Length of an input or a textarea cannot be negative.');
            }
            this._refreshValue();
        }
    }
    ngAfterContentInit() {
        if (this.length) {
            setTimeout(() => {
                this.createMaxLengthBox();
                this._refreshValue();
            });
        }
        if (this.control?.valueChanges) {
            this.valueChangesSubscription = this.control.valueChanges.subscribe(() => {
                this._refreshValue();
            });
        }
    }
    onChange(event) {
        setTimeout(() => {
            if (!this.control) {
                this._refreshValue();
            }
        }, 100);
    }
    onInput(event) {
        if (!this.control) {
            this._refreshValue();
        }
    }
    _refreshValue() {
        let input = this.el.nativeElement;
        let remainingLength = this.length - input.value.length;
        if (remainingLength < 0 && this.maxLengthSpan) {
            this.renderer.addClass(this.maxLengthSpan, 'error');
            this.renderer.setProperty(input, 'maxLength', this.length);
            this.renderer.setProperty(input, 'value', input.value.substr(0, this.length));
            this.setValue(input.value.substr(0, this.length), input);
            this.renderer.setProperty(this.maxLengthSpan, 'innerHTML', '0');
            this.validityChange.emit(false);
        }
        else {
            if (remainingLength <= 0 && this.maxLengthSpan) {
                this.renderer.addClass(this.maxLengthSpan, 'error');
                this.validityChange.emit(false);
                if (remainingLength < 0) {
                    this.setValue(input.value.substr(0, input.value.length - 1), input);
                }
            }
            if (remainingLength >= 0 && this.maxLengthSpan) {
                this.renderer.setProperty(this.maxLengthSpan, 'innerHTML', (this.length - input.value.length).toString());
            }
            if (remainingLength > 0 && this.maxLengthSpan) {
                this.renderer.removeClass(this.maxLengthSpan, 'error');
                this.validityChange.emit(true);
            }
        }
    }
    /**
     * updates the model value and takes into consideration the NgControl
     * @param value the value to be used
     * @param input the Input element to be updated
     * @private
     */
    setValue(value, input) {
        if (this.control) {
            this.control.reset(value);
        }
        else {
            this.renderer.setProperty(input, 'value', value);
        }
    }
    /**
     * creates the maxLength box by adding it to DOM and attaching correct Classes
     * for Wrapper and Span (actual box holding max length)
     * @private
     */
    createMaxLengthBox() {
        // creates the span that holds the max length value which changes according to input
        this.maxLengthSpan = this.renderer.createElement('span');
        this.renderer.addClass(this.maxLengthSpan, 'input-maxlength');
        this.renderer.setProperty(this.maxLengthSpan, 'innerHTML', this.length.toString());
        // create wrapper element
        let nativeElement = this.el.nativeElement;
        if (nativeElement != null) {
            let parent = nativeElement.parentNode;
            if (parent != null && this.isShowMaxlengthCounter) {
                // creates wrapper div of input and maxLength span
                this.wrapper = this.renderer.createElement('div');
                this.renderer.addClass(this.wrapper, 'input-maxlength-wrapper');
                // swap, wrapper should wrap the nativeElement and maxLength span
                parent.replaceChild(this.wrapper, nativeElement);
                this.renderer.appendChild(this.wrapper, nativeElement);
                this.renderer.appendChild(nativeElement.parentElement, this.maxLengthSpan);
            }
        }
    }
    /**
     * destroys the maxLength box from DOM
     * @private
     */
    destroyMaxLengthBox() {
        // removes maxlength element from DOM
        if (this.maxLengthSpan) {
            this.renderer.removeChild(this.wrapper, this.maxLengthSpan);
        }
        // remove wrapper from DOM
        if (this.wrapper) {
            // get parent node of wrapper
            let parent = this.wrapper.parentNode;
            let nativeElement = this.el.nativeElement;
            // swap wrapper and nativeElement
            parent.replaceChild(nativeElement, this.wrapper);
            // removes wrapper element from DOM
            this.renderer.removeChild(parent, this.wrapper);
        }
    }
}
/** @nocollapse */ UxMaxlengthDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxMaxlengthDirective, deps: [{ token: i0.ElementRef }, { token: i1.NgControl, optional: true, self: true }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ UxMaxlengthDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: UxMaxlengthDirective, selector: "input[type=\"text\"][uxMaxlength], input[type=\"password\"][uxMaxlength], textarea[uxMaxlength]", inputs: { length: ["uxMaxlength", "length"], isShowMaxlengthCounter: "isShowMaxlengthCounter" }, outputs: { validityChange: "validityChange" }, host: { listeners: { "change": "onChange($event)", "input": "onInput($event)" } }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxMaxlengthDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[type="text"][uxMaxlength], ' +
                        'input[type="password"][uxMaxlength], ' +
                        'textarea[uxMaxlength]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }, { type: i0.Renderer2 }]; }, propDecorators: { length: [{
                type: Input,
                args: ['uxMaxlength']
            }], isShowMaxlengthCounter: [{
                type: Input,
                args: ['isShowMaxlengthCounter']
            }], validityChange: [{
                type: Output
            }], onChange: [{
                type: HostListener,
                args: ['change', ['$event']]
            }], onInput: [{
                type: HostListener,
                args: ['input', ['$event']]
            }] } });
class UxMaxlengthModule {
}
/** @nocollapse */ UxMaxlengthModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxMaxlengthModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxMaxlengthModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxMaxlengthModule, declarations: [UxMaxlengthDirective], imports: [CommonModule], exports: [UxMaxlengthDirective] });
/** @nocollapse */ UxMaxlengthModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxMaxlengthModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxMaxlengthModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [UxMaxlengthDirective],
                    declarations: [UxMaxlengthDirective]
                }]
        }] });

class UxTooltipDirective {
    constructor(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        // Text of the tooltip
        this.text = '';
        // Position of the tooltip compared to the element
        this.position = 'top';
        // Forced size of the tooltip. Anything else will cause the tooltip to shrink to fit, and stay on a single line.
        this.size = 'auto';
        this._rounded = false;
        this._always = false;
        // Tooltip z-index over other elements
        this.zIndex = 'auto';
        this.prefix = 'hint--';
        this._color = 'none';
        this._el = elementRef.nativeElement;
    }
    // Tooltip color. Using anything else, include 'none', will result in the default black background with white text
    get color() {
        return this._color;
    }
    set color(color) {
        if (!color) {
            this._color = 'none';
        }
        this._color = color;
    }
    // Rounded edges of tooltip
    get rounded() { return this._rounded; }
    set rounded(value) { this._rounded = coerceBooleanProperty(value); }
    // Tooltip always displays even on mouseout and onfocusout
    get always() { return this._always; }
    set always(value) { this._always = coerceBooleanProperty(value); }
    ngOnChanges(changes) {
        if (!changes.firstChange) {
            if (changes.text) {
                this.renderer.setAttribute(this._el, 'data-hint', changes.text.currentValue);
            }
            if (changes.color) {
                this._removeClass(this._el, this.prefix + changes.color.previousValue);
                this._addClass(this._el, this.prefix + changes.color.currentValue);
            }
            if (changes.position) {
                this._removeClass(this._el, this.prefix + changes.position.previousValue);
                this._addClass(this._el, this.prefix + changes.position.currentValue);
            }
            if (changes.size) {
                this._removeClass(this._el, this.prefix + changes.size.previousValue);
                this._addClass(this._el, this.prefix + changes.size.currentValue);
            }
            if (changes.zIndex) {
                this._removeClass(this._el, 'ux-u-z-index-' + changes.zIndex.previousValue);
                this._addClass(this._el, 'ux-u-z-index-' + changes.zIndex.currentValue);
            }
            if (changes.rounded) {
                if (changes.rounded.currentValue) {
                    this._addClass(this._el, this.prefix + 'rounded');
                }
                else {
                    this._removeClass(this._el, this.prefix + 'rounded');
                }
            }
            if (changes.always) {
                if (changes.always.currentValue) {
                    this._addClass(this._el, this.prefix + 'always');
                }
                else {
                    this._removeClass(this._el, this.prefix + 'always');
                }
            }
        }
    }
    onFocusOrMouseover() {
        if (!this.text || this.text.length === 0) {
            return;
        }
        else {
            this.setClasses();
        }
    }
    setClasses() {
        if (this.position) {
            this._addClass(this._el, this.prefix + this.position);
        }
        if (this.color) {
            this._addClass(this._el, this.prefix + this.color);
        }
        if (this.size) {
            this._addClass(this._el, this.prefix + this.size);
        }
        if (this.zIndex) {
            this._addClass(this._el, 'ux-u-z-index-' + this.zIndex);
        }
        if (this.always) {
            this._addClass(this._el, this.prefix + 'always');
        }
        if (this.rounded) {
            this._addClass(this._el, this.prefix + 'rounded');
        }
    }
    _addClass(element, className) {
        this.renderer.addClass(element, className);
    }
    _removeClass(element, className) {
        this.renderer.removeClass(element, className);
    }
}
/** @nocollapse */ UxTooltipDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxTooltipDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ UxTooltipDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: UxTooltipDirective, selector: "[uxTooltip]", inputs: { color: "color", text: ["uxTooltip", "text"], position: "position", size: "size", rounded: "rounded", always: "always", zIndex: "zIndex" }, host: { listeners: { "focus": "onFocusOrMouseover()", "mouseover": "onFocusOrMouseover()" } }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxTooltipDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[uxTooltip]'
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { color: [{
                type: Input
            }], text: [{
                type: Input,
                args: ['uxTooltip']
            }], position: [{
                type: Input
            }], size: [{
                type: Input
            }], rounded: [{
                type: Input
            }], always: [{
                type: Input
            }], zIndex: [{
                type: Input
            }], onFocusOrMouseover: [{
                type: HostListener,
                args: ['focus']
            }, {
                type: HostListener,
                args: ['mouseover']
            }] } });
class UxTooltipModule {
}
/** @nocollapse */ UxTooltipModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxTooltipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxTooltipModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxTooltipModule, declarations: [UxTooltipDirective], imports: [CommonModule], exports: [UxTooltipDirective] });
/** @nocollapse */ UxTooltipModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxTooltipModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxTooltipModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [UxTooltipDirective],
                    declarations: [UxTooltipDirective]
                }]
        }] });

class UxAutoResizeDirective {
    constructor(el, asService, controlContainer) {
        this.el = el;
        this.asService = asService;
        this.controlContainer = controlContainer;
        this.defaultRows = 1;
        this.uxAutoResize = true;
        this.windowResizedSubscription = fromEvent(window, 'resize')
            .pipe(debounceTime(300))
            .subscribe((event) => {
            this.resize();
        });
    }
    // TODO: remove since it's useless business wise (already covered by rows)
    set minRows(minRows) {
        this.defaultRows = minRows;
    }
    onInput(textArea) {
        this.resize();
    }
    ngOnInit() {
        if (this.uxAutoResize === '') {
            this.uxAutoResize = true;
        }
        if (this.uxAutoResize) {
            // defaultRows needs to be greater than rows to take effect
            if (this.defaultRows) {
                this.el.nativeElement.rows = this.defaultRows > this.el.nativeElement.rows ? this.defaultRows : this.el.nativeElement.rows;
            }
            this.el.nativeElement.style.overflow = 'hidden';
            this.el.nativeElement.style.resize = 'none';
        }
        // emit while height is auto and resize() then observable completes
        // this is important cause there's no other way to know when element rendered in DOM
        this.resizeSubscription = timer(1000).pipe(takeWhile(() => this.el.nativeElement.style.height === 'auto')).subscribe(() => {
            this.resize();
        });
    }
    ngAfterViewInit() {
        if (this.uxAutoResize) {
            // In case auto-resize inputs are being used inside modal dialogs, we have to wait until the
            // modal dialog is open before we resize:
            const modalParent = this.findAncestorByClass(this.el.nativeElement, 'ux-modal');
            if (modalParent != null) {
                this.parentModalId = modalParent.id;
                this.openModalIdSubscription = this.asService.openModalId.subscribe((modalId) => {
                    if (modalId === this.parentModalId) {
                        setTimeout(() => {
                            this.resize();
                        }, 0);
                    }
                });
            }
            setTimeout(() => {
                this.resize();
            }, 0);
            this.handleFormControlChanges();
        }
    }
    ngOnDestroy() {
        if (this.openModalIdSubscription) {
            this.openModalIdSubscription.unsubscribe();
        }
        if (this.windowResizedSubscription) {
            this.windowResizedSubscription.unsubscribe();
        }
        if (this.resizeSubscription) {
            this.resizeSubscription.unsubscribe();
        }
    }
    resize() {
        if (this.uxAutoResize) {
            this.el.nativeElement.style.height = 'auto';
            let offset = this.el.nativeElement.offsetHeight, scroll = this.el.nativeElement.scrollHeight;
            let height = (offset > scroll ? offset : scroll);
            if (height <= 0) {
                height = 'auto';
            }
            else {
                height += 'px';
            }
            this.el.nativeElement.style.height = height;
        }
    }
    findAncestorByClass(el, cls) {
        let element = el.parentElement;
        while (element && !element.classList.contains(cls)) {
            element = element.parentElement;
        }
        return element;
    }
    handleFormControlChanges() {
        const fg = this.getFormGroup();
        if (fg) {
            fg.valueChanges
                .subscribe(v => {
                setTimeout(() => {
                    this.resize();
                }, 0);
            });
        }
    }
    getFormGroup() {
        if (this.controlContainer && this.controlContainer.formDirective) {
            return this.controlContainer.formDirective.form;
        }
        return null;
    }
}
/** @nocollapse */ UxAutoResizeDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxAutoResizeDirective, deps: [{ token: i0.ElementRef }, { token: i1$1.UxAppShellService }, { token: i1.ControlContainer, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ UxAutoResizeDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: UxAutoResizeDirective, selector: "textarea[uxAutoResize]", inputs: { uxAutoResize: "uxAutoResize", minRows: "minRows" }, host: { listeners: { "input": "onInput($event.target)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxAutoResizeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'textarea[uxAutoResize]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1$1.UxAppShellService }, { type: i1.ControlContainer, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { uxAutoResize: [{
                type: Input
            }], minRows: [{
                type: Input
            }], onInput: [{
                type: HostListener,
                args: ['input', ['$event.target']]
            }] } });
class UxAutoResizeModule {
}
/** @nocollapse */ UxAutoResizeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxAutoResizeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxAutoResizeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxAutoResizeModule, declarations: [UxAutoResizeDirective], imports: [CommonModule], exports: [UxAutoResizeDirective] });
/** @nocollapse */ UxAutoResizeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxAutoResizeModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxAutoResizeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [UxAutoResizeDirective],
                    declarations: [UxAutoResizeDirective],
                }]
        }] });

class UxCollapsibleDirective {
    constructor(el) {
        this.el = el;
        this.isFinishedMoving = true;
        this.isExpanded = true;
        this.isMoving = false;
        this._uxExpanded = true;
        this._uxCollapsed = false;
        this.transitionDuration = '0.35s';
        this.container = el.nativeElement;
        this.containerStyle = this.container.style;
        this.containerStyle.overflow = 'hidden';
        this.containerStyle.transform = 'translate3d(0, 0, 0)';
        let display = this.containerStyle.display;
        if (display == null || display.length <= 0) {
            this.containerStyle.display = 'block';
        }
    }
    get uxExpanded() { return this._uxExpanded; }
    set uxExpanded(value) { this._uxExpanded = coerceBooleanProperty(value); }
    get uxCollapsed() { return this._uxCollapsed; }
    set uxCollapsed(value) { this._uxCollapsed = coerceBooleanProperty(value); }
    ngOnChanges(changes) {
        let change = changes['uxCollapsed'];
        if (change != null && !change.isFirstChange()) {
            if (this.uxCollapsed) {
                this.collapse();
            }
            else {
                this.expand();
            }
        }
        change = changes['uxExpanded'];
        if (change != null && !change.isFirstChange()) {
            if (this.uxExpanded) {
                this.expand();
            }
            else {
                this.collapse();
            }
        }
    }
    ngAfterContentInit() {
        this.containerStyle.transitionDuration = '0';
        if (this.uxCollapsed || !this.uxExpanded || this.container.getAttribute('aria-expanded') === 'false') {
            this.isExpanded = false;
            this.containerStyle.height = '0';
        }
        else {
            this.containerStyle.height = 'auto'; // Set it to auto to ensure a working resizing.
        }
    }
    collapse() {
        if (this.isExpanded) {
            if (this.animation != null) {
                this.animation.unsubscribe();
            }
            this.animation = concat(of(() => {
                this.disableFocus();
                this.isMoving = true;
                this.isFinishedMoving = false;
                // Temporarily disable the transition to ensure a transition from and actual height value.
                this.containerStyle.transitionDuration = '0';
            }), timer(20)
                .pipe(switchMapTo(of(() => {
                // Set it to the current height first to ensure the animation on the 'height' property.
                this.containerStyle.height = this.container.offsetHeight + 'px';
                this.containerStyle.transitionDuration = this.transitionDuration;
            }))), timer(20)
                .pipe(switchMapTo(of(() => {
                this.containerStyle.opacity = '1.0';
                this.containerStyle.height = '0';
            }))), timer(350)
                .pipe(switchMapTo(of(() => {
                this.isExpanded = false;
                this.isFinishedMoving = true;
                this.isMoving = false;
                this.containerStyle.transitionDuration = '0';
            })))).subscribe(f => f());
        }
    }
    expand() {
        if (!this.isExpanded) {
            if (this.animation != null) {
                this.animation.unsubscribe();
            }
            let height = 0;
            this.animation = concat(of(() => {
                this.enableFocus();
                this.isMoving = false;
                this.isFinishedMoving = false;
                // Temporarily disable the transition to ensure a transition from an actual height value.
                this.containerStyle.transitionDuration = '0';
                // Also make the content invisible to know the actual current height.
                this.containerStyle.opacity = '0';
            }), timer(0)
                .pipe(switchMapTo(of(() => {
                this.containerStyle.height = 'auto';
                height = this.container.offsetHeight;
                this.containerStyle.height = '0'; // Set it first back to 0 to ensure the animation on the 'height' property.
            }))), timer(20)
                .pipe(switchMapTo(of(() => {
                this.containerStyle.transitionDuration = this.transitionDuration;
                this.containerStyle.opacity = '1.0';
            }))), timer(20)
                .pipe(switchMapTo(of(() => {
                this.containerStyle.height = height + 'px';
            }))), timer(350)
                .pipe(switchMapTo(of(() => {
                this.isExpanded = true;
                this.isFinishedMoving = true;
                this.isMoving = false;
                this.containerStyle.height = 'auto'; // Set it to auto to ensure a working resizing.
                this.containerStyle.transitionDuration = '0';
            })))).subscribe(f => f());
        }
    }
    disableFocus() {
        let focusedElement = this.container.querySelector(':focus');
        if (focusedElement != null) {
            focusedElement.blur();
        }
        let elements = this.container.querySelectorAll('*');
        for (let i = 0; i < elements.length; i++) {
            let element = elements[i];
            let tabIndex = element.getAttribute('tabindex');
            if (tabIndex != null) {
                element.setAttribute('data-prev-tabindex', tabIndex);
            }
            element.setAttribute('tabindex', '-1');
        }
    }
    enableFocus() {
        let elements = this.container.querySelectorAll('*');
        for (let i = 0; i < elements.length; i++) {
            let element = elements[i];
            let prevTabIndex = element.getAttribute('data-prev-tabindex');
            if (prevTabIndex != null) {
                element.setAttribute('tabindex', prevTabIndex);
            }
            else {
                element.removeAttribute('tabindex');
            }
        }
    }
}
/** @nocollapse */ UxCollapsibleDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxCollapsibleDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ UxCollapsibleDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: UxCollapsibleDirective, selector: "[uxCollapsible]", inputs: { uxExpanded: "uxExpanded", uxCollapsed: "uxCollapsed" }, host: { properties: { "class.collapse": "this.isFinishedMoving", "class.in": "this.isExpanded", "attr.aria-expanded": "this.isExpanded", "class.collapsing": "this.isMoving" } }, exportAs: ["uxCollapsible"], usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxCollapsibleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[uxCollapsible]',
                    exportAs: 'uxCollapsible',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { isFinishedMoving: [{
                type: HostBinding,
                args: ['class.collapse']
            }], isExpanded: [{
                type: HostBinding,
                args: ['class.in']
            }, {
                type: HostBinding,
                args: ['attr.aria-expanded']
            }], isMoving: [{
                type: HostBinding,
                args: ['class.collapsing']
            }], uxExpanded: [{
                type: Input
            }], uxCollapsed: [{
                type: Input
            }] } });
class UxCollapsibleDirectiveModule {
}
/** @nocollapse */ UxCollapsibleDirectiveModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxCollapsibleDirectiveModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxCollapsibleDirectiveModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxCollapsibleDirectiveModule, declarations: [UxCollapsibleDirective], imports: [CommonModule], exports: [UxCollapsibleDirective] });
/** @nocollapse */ UxCollapsibleDirectiveModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxCollapsibleDirectiveModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxCollapsibleDirectiveModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [UxCollapsibleDirective],
                    declarations: [UxCollapsibleDirective],
                }]
        }] });

/* eslint-disable */
/* eslint-enable */
class UxHasPermissionDirective {
    constructor(element, templateRef, viewContainer, permissionService) {
        this.element = element;
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.permissionService = permissionService;
        this.permissions = [];
        this.isHidden = true;
    }
    set hasPermission(val) {
        this.permissions = val;
        this.updateView();
    }
    ngOnInit() {
        this.updateView();
    }
    updateView() {
        if (this.checkPermission()) {
            if (this.isHidden) {
                this.viewContainer.createEmbeddedView(this.templateRef);
                this.isHidden = false;
            }
        }
        else {
            this.isHidden = true;
            this.viewContainer.clear();
        }
    }
    checkPermission() {
        let hasPermission = true;
        // for start it checks with and operator
        this.permissions.forEach((permission) => {
            hasPermission = this.permissionService.checkAttributePermission(permission) && hasPermission;
        });
        return hasPermission;
    }
}
/** @nocollapse */ UxHasPermissionDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxHasPermissionDirective, deps: [{ token: i0.ElementRef }, { token: i0.TemplateRef }, { token: i0.ViewContainerRef }, { token: i1$1.EuiPermissionService }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ UxHasPermissionDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: UxHasPermissionDirective, selector: "[hasPermission]", inputs: { hasPermission: "hasPermission" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxHasPermissionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[hasPermission]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.TemplateRef }, { type: i0.ViewContainerRef }, { type: i1$1.EuiPermissionService }]; }, propDecorators: { hasPermission: [{
                type: Input
            }] } });
class UxHasPermissionDirectiveModule {
}
/** @nocollapse */ UxHasPermissionDirectiveModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxHasPermissionDirectiveModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxHasPermissionDirectiveModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxHasPermissionDirectiveModule, declarations: [UxHasPermissionDirective], imports: [CommonModule], exports: [UxHasPermissionDirective] });
/** @nocollapse */ UxHasPermissionDirectiveModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxHasPermissionDirectiveModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxHasPermissionDirectiveModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [UxHasPermissionDirective],
                    declarations: [UxHasPermissionDirective],
                }]
        }] });

/* https://www.npmjs.com/package/ng2-smooth-scroll
   https://github.com/kavil/ng2SmoothScroll/blob/master/lib/ng2-SmoothScroll.directive.ts
*/
class UxSmoothScrollToDirective {
    constructor() { }
    onClick() {
        this.targetElement = document.getElementById(this.scrollTo);
        if (!this.targetElement) {
            return;
        }
        new SmoothScroll(this.targetElement, {
            duration: this.duration,
            offset: this.offset,
            easing: this.easing,
            callbackBefore: this.callbackBefore,
            callbackAfter: this.callbackAfter,
            containerId: this.containerId,
            middleAlign: this.middleAlign
        });
    }
    ;
}
/** @nocollapse */ UxSmoothScrollToDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxSmoothScrollToDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ UxSmoothScrollToDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: UxSmoothScrollToDirective, selector: "[uxScrollTo]", inputs: { scrollTo: ["uxScrollTo", "scrollTo"], duration: "duration", offset: "offset", easing: "easing", callbackBefore: "callbackBefore", callbackAfter: "callbackAfter", containerId: "containerId", middleAlign: "middleAlign" }, host: { listeners: { "click": "onClick()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxSmoothScrollToDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[uxScrollTo]'
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { scrollTo: [{
                type: Input,
                args: ['uxScrollTo']
            }], duration: [{
                type: Input,
                args: ['duration']
            }], offset: [{
                type: Input,
                args: ['offset']
            }], easing: [{
                type: Input,
                args: ['easing']
            }], callbackBefore: [{
                type: Input,
                args: ['callbackBefore']
            }], callbackAfter: [{
                type: Input,
                args: ['callbackAfter']
            }], containerId: [{
                type: Input,
                args: ['containerId']
            }], middleAlign: [{
                type: Input,
                args: ['middleAlign']
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });
class UxSmoothScrollDirective {
    constructor(el) {
        this.el = el;
    }
    onClick(target) {
        if (this.scrollOnClick) {
            this.scroll();
        }
    }
    ;
    ngOnInit() {
        this.scroll();
    }
    scroll() {
        if (typeof this.scrollIf === 'undefined' || this.scrollIf === true) {
            setTimeout(() => {
                new SmoothScroll(this.el.nativeElement, {
                    duration: this.duration,
                    offset: this.offset,
                    easing: this.easing,
                    callbackBefore: this.callbackBefore,
                    callbackAfter: this.callbackAfter,
                    containerId: this.containerId,
                    middleAlign: this.middleAlign
                });
            }, 0);
        }
    }
}
/** @nocollapse */ UxSmoothScrollDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxSmoothScrollDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ UxSmoothScrollDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: UxSmoothScrollDirective, selector: "[uxSmoothScroll]", inputs: { scrollIf: "scrollIf", duration: "duration", offset: "offset", easing: "easing", callbackBefore: "callbackBefore", callbackAfter: "callbackAfter", containerId: "containerId", scrollOnClick: "scrollOnClick", middleAlign: "middleAlign" }, host: { listeners: { "click": "onClick($event.target)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxSmoothScrollDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[uxSmoothScroll]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { scrollIf: [{
                type: Input,
                args: ['scrollIf']
            }], duration: [{
                type: Input,
                args: ['duration']
            }], offset: [{
                type: Input,
                args: ['offset']
            }], easing: [{
                type: Input,
                args: ['easing']
            }], callbackBefore: [{
                type: Input,
                args: ['callbackBefore']
            }], callbackAfter: [{
                type: Input,
                args: ['callbackAfter']
            }], containerId: [{
                type: Input,
                args: ['containerId']
            }], scrollOnClick: [{
                type: Input,
                args: ['scrollOnClick']
            }], middleAlign: [{
                type: Input,
                args: ['middleAlign']
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event.target']]
            }] } });
class SmoothScroll {
    constructor(element, options) {
        this.smoothScroll(element, options);
    }
    smoothScroll(element, options) {
        options = options || {};
        // Options
        let duration = options.duration || 800, offset = options.offset || 0, easing = options.easing || 'easeInOutQuart', callbackBefore = options.callbackBefore || function () { }, callbackAfter = options.callbackAfter || function () { }, container = document.getElementById(options.containerId) || null, containerPresent = (container != undefined && container != null), middleAlign = options.middleAlign || false;
        /**
         * Retrieve current location
         */
        let getScrollLocation = function () {
            if (containerPresent) {
                return container.scrollTop;
            }
            else {
                if (window.pageYOffset) {
                    return window.pageYOffset;
                }
                else {
                    return document.documentElement.scrollTop;
                }
            }
        };
        /**
         * Calculate easing pattern.
         *
         * 20150713 edit - zephinzer
         * - changed if-else to switch
         * @see http://archive.oreilly.com/pub/a/server-administration/excerpts/even-faster-websites/writing-efficient-javascript.html
         */
        let getEasingPattern = function (type, time) {
            switch (type) {
                case 'easeInQuad': return time * time; // accelerating from zero velocity
                case 'easeOutQuad': return time * (2 - time); // decelerating to zero velocity
                case 'easeInOutQuad': return time < 0.5 ? 2 * time * time : -1 + (4 - 2 * time) * time; // acceleration until halfway, then deceleration
                case 'easeInCubic': return time * time * time; // accelerating from zero velocity
                case 'easeOutCubic': return (--time) * time * time + 1; // decelerating to zero velocity
                case 'easeInOutCubic': return time < 0.5 ? 4 * time * time * time : (time - 1) * (2 * time - 2) * (2 * time - 2) + 1; // acceleration until halfway, then deceleration
                case 'easeInQuart': return time * time * time * time; // accelerating from zero velocity
                case 'easeOutQuart': return 1 - (--time) * time * time * time; // decelerating to zero velocity
                case 'easeInOutQuart': return time < 0.5 ? 8 * time * time * time * time : 1 - 8 * (--time) * time * time * time; // acceleration until halfway, then deceleration
                case 'easeInQuint': return time * time * time * time * time; // accelerating from zero velocity
                case 'easeOutQuint': return 1 + (--time) * time * time * time * time; // decelerating to zero velocity
                case 'easeInOutQuint': return time < 0.5 ? 16 * time * time * time * time * time : 1 + 16 * (--time) * time * time * time * time; // acceleration until halfway, then deceleration
                default: return time;
            }
        };
        /**
         * Calculate how far to scroll
         */
        let getEndLocation = function (element) {
            let location = 0, elementRect = element.getBoundingClientRect(), absoluteElementTop = elementRect.top + window.pageYOffset;
            if (middleAlign) {
                location = (absoluteElementTop + (element.offsetHeight / 2)) - (window.innerHeight / 2);
            }
            else {
                location = absoluteElementTop;
            }
            if (offset) {
                location = location - offset;
            }
            return Math.max(location, 0);
        };
        // Initialize the whole thing
        setTimeout(function () {
            let currentLocation = null, startLocation = getScrollLocation(), endLocation = getEndLocation(element), timeLapsed = 0, distance = endLocation - startLocation, percentage, position, scrollHeight, internalHeight;
            /**
             * Stop the scrolling animation when the anchor is reached (or at the top/bottom of the page)
             */
            let stopAnimation = function () {
                currentLocation = getScrollLocation();
                if (containerPresent) {
                    scrollHeight = container.scrollHeight;
                    internalHeight = container.clientHeight + currentLocation;
                }
                else {
                    scrollHeight = document.body.scrollHeight;
                    internalHeight = window.innerHeight + currentLocation;
                }
                if (( // condition 1
                position == endLocation) ||
                    ( // condition 2
                    currentLocation == endLocation) ||
                    ( // condition 3
                    internalHeight > scrollHeight)) { // stop
                    clearInterval(runAnimation);
                    callbackAfter(element);
                }
            };
            /**
             * Scroll the page by an increment, and check if it's time to stop
             */
            let animateScroll = function () {
                timeLapsed += 16;
                percentage = (timeLapsed / duration);
                percentage = (percentage > 1) ? 1 : percentage;
                position = startLocation + (distance * getEasingPattern(easing, percentage));
                if (containerPresent) {
                    container.scrollTop = position;
                }
                else {
                    window.scrollTo(0, position);
                }
                stopAnimation();
            };
            callbackBefore(element);
            let runAnimation = setInterval(animateScroll, 16);
        }, 0);
    }
}
class UxSmoothScrollDirectiveModule {
}
/** @nocollapse */ UxSmoothScrollDirectiveModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxSmoothScrollDirectiveModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxSmoothScrollDirectiveModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxSmoothScrollDirectiveModule, declarations: [UxSmoothScrollToDirective, UxSmoothScrollDirective], imports: [CommonModule], exports: [UxSmoothScrollToDirective, UxSmoothScrollDirective] });
/** @nocollapse */ UxSmoothScrollDirectiveModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxSmoothScrollDirectiveModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxSmoothScrollDirectiveModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [UxSmoothScrollToDirective, UxSmoothScrollDirective],
                    declarations: [UxSmoothScrollToDirective, UxSmoothScrollDirective]
                }]
        }] });

/**
 * Retrieve the thousand and decimal separator using angular's helper function
 * @param locale the locale_id based on angular Injection Token
 */
function getSeparators(locale) {
    // get formatNumber based on locale
    const numberFormat = getLocaleNumberFormat(locale, NumberFormatStyle.Decimal);
    // based on given format extract decimal and thousand separators
    // TODO: this could be easily done with Array Destructuring (ES6 feat) but it's disabled in current tsconfig :/
    const format = numberFormat.split('#').join('').split('0').join('');
    return { thousand: format[0], decimal: format[1] };
}

class UxCleaveDirective {
    constructor(el, locale, cdr, renderer) {
        this.el = el;
        this.locale = locale;
        this.cdr = cdr;
        this.renderer = renderer;
        this._isModelNumber = false;
        this.onChange = (_) => { };
        this.onTouched = () => { };
        // retrieve the thousand and decimal separators based on current locale ID
        const { thousand, decimal } = getSeparators(locale);
        // initialize the options object for Cleave.JS with current locale
        this.options = {
            numeral: true,
            numeralDecimalMark: decimal,
            delimiter: thousand // thousandSeparator
        };
        // change the cleave prototype function to intercept onCut callback
        // and allow based on the event bubbling and disabled state
        // TIP: change behavior of onCut to stop in case bubble is canceled
        // TODO: See relevant issue https://github.com/nosir/cleave.js/issues/675
        const _onCut = Cleave.prototype['onCut'];
        Cleave.prototype['onCut'] = function (e) {
            // eslint-disable-next-line no-invalid-this
            if (!e.cancelBubble && !this.element.disabled) {
                // eslint-disable-next-line no-invalid-this
                _onCut.call(this, e);
            }
        };
        // TODO: listen for locale changes and apply them if cleave options are not provided
    }
    /** when enabled number is rendered as text and cannot be edited */
    get readOnly() { return this._readOnly; }
    set readOnly(value) { this._readOnly = coerceBooleanProperty(value); }
    /** model value can be number or string - default is string */
    get isModelNumber() { return this._isModelNumber; }
    set isModelNumber(value) { this._isModelNumber = coerceBooleanProperty(value); }
    ngOnInit() {
        // create the div element that rendered when readOnly is true. It is important to init at constructor level
        // because ngOnChange will run before ngOnInit or afterContentViewInit and by that time this.readOnlyElement
        // will be null causing the css display of the element to not have the correct value.
        this.initReadOnlyElement();
        // initiate the cleave instance
        this.initCleave();
    }
    ngOnChanges(changes) {
        if (changes && changes['readOnly'] && this.readOnlyElement) {
            // set the Value
            this.renderer.setProperty(this.readOnlyElement, 'innerHTML', this.el.nativeElement.value);
            // hide or show Input and Div element based on readOnly mode
            this.renderer.setStyle(this.el.nativeElement, 'display', this.readOnly ? 'none' : 'block');
            this.renderer.setStyle(this.readOnlyElement, 'display', this.readOnly ? 'block' : 'none');
        }
        if (changes && changes['isModelNumber'] && this.cleaveInstance) {
            let value = this.cleaveInstance.getRawValue();
            this.onChange(this.isModelNumber ? this.convertToNumber(value) : value);
            this.cdr.detectChanges();
        }
        if (changes && changes['options']) {
            // handle error if option is not available
            if (typeof changes['options'].currentValue === 'string' && this.options === null) {
                throw Error(`Angular Cleave: option is not valid (${this.options}).\n`);
            }
            // Cleave.js options object
            if (typeof changes['options'].currentValue === 'object') {
                // in case is numeral
                if (this.options.numeral) {
                    // check if only decimal provided and set thousand
                    if (this.options.delimiter === undefined) {
                        this.options.delimiter = this.options.numeralDecimalMark === ' ' ? ',' : ' ';
                    }
                    // check if only thousand provided and set decimal
                    if (this.options.numeralDecimalMark === undefined) {
                        this.options.numeralDecimalMark = this.options.delimiter === '.' ? ',' : '.';
                    }
                    // check if similar provided
                    if (this.options.delimiter && this.options.delimiter === this.options.numeralDecimalMark) {
                        throw Error(`Angular Cleave: option delimiter and numeralDecimalMark cannot be the same.\n`);
                        // normalize
                        if (this.options.numeralDecimalMark === '.') {
                            this.options.delimiter = ',';
                        }
                        else {
                            this.options.numeralDecimalMark = '.';
                        }
                    }
                }
                // rebuild the cleave instance - no method for options update has been found
                this.updateOptions();
            }
        }
    }
    ngOnDestroy() {
        // destroy cleave instance
        if (this.cleaveInstance) {
            this.cleaveInstance.destroy();
        }
        // remove listener if readOnly element is present
        if (this.readOnlyElement) {
            this.copyListener();
        }
    }
    /**
     * sets the number for cleave instance and div element (read only mode)
     * @param val the number formatted or not
     */
    writeValue(val) {
        if (this.cleaveInstance) {
            this.cleaveInstance.setRawValue(val);
            this.renderer.setProperty(this.readOnlyElement, 'innerHTML', this.cleaveInstance.getFormattedValue());
        }
    }
    setDisabledState(isDisabled) {
        this.renderer.setProperty(this.el.nativeElement, 'disabled', isDisabled);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * instantiate Cleave.js
     */
    initCleave() {
        // in case options is undefined
        const opts = { ...this.options };
        // set the onValue change listener to keep the value at readOnly element in sync
        opts.onValueChanged = this.onValueChanged.bind(this);
        // create the Cleave instance with the new or updated options
        this.cleaveInstance = new Cleave(this.el.nativeElement, opts);
        // hide or show Input based on readOnly mode
        this.renderer.setStyle(this.el.nativeElement, 'display', this.readOnly ? 'none' : 'block');
    }
    /**
     * Updates the cleave options by destroying the current instance and creating another one while keeping the previous
     * value.
     */
    updateOptions() {
        if (this.cleaveInstance) {
            // the value before destroying cleave instance
            let previousValue = this.cleaveInstance.getRawValue();
            // destroy previous instance from the element
            this.cleaveInstance.destroy();
            // create the Cleave instance with the new or updated options
            this.cleaveInstance = new Cleave(this.el.nativeElement, {
                ...this.options,
                initValue: previousValue,
                onValueChanged: this.onValueChanged.bind(this)
            });
            // In case previous settings where numeralDecimalMark='.' with value 1000.99 and they changed to
            // numeralDecimalMark=','; set initValue to 1000.99 or even 1000,99 will not be reflected and cleave will
            // remove the decimal part. Set of the value after initialization causes reformat of number and works.
            this.cleaveInstance.setRawValue(previousValue);
        }
    }
    /**
     * Callback function of the Cleave instance that is invoked when value is changed.
     * @param event type of CleaveEventOnChange
     */
    onValueChanged(event) {
        const { target } = event;
        this.renderer.setProperty(this.readOnlyElement, 'innerHTML', target.value);
        this.onChange(this.isModelNumber ? this.convertToNumber(target.rawValue) : target.rawValue);
        this.cdr.detectChanges();
    }
    /**
     * create the readOnly as Div element, configure CSS display and listen to copy event to return number when copied.
     */
    initReadOnlyElement() {
        // create a Div element for readonly
        this.readOnlyElement = this.renderer.createElement('div');
        this.renderer.setAttribute(this.readOnlyElement, 'id', 'readonly');
        this.renderer.setAttribute(this.readOnlyElement, 'class', 'ux-form-group--read-only');
        this.renderer.setStyle(this.readOnlyElement, 'display', this.readOnly ? 'block' : 'none');
        this.renderer.setProperty(this.readOnlyElement, 'innerHTML', this.el.nativeElement.value);
        // add copy event listener to get number instead of formatted value
        this.copyListener = this.renderer.listen(this.readOnlyElement, 'copy', (event) => {
            event.clipboardData.setData('text/plain', this.cleaveInstance.getRawValue());
            event.preventDefault();
        });
        /**
         * Insert the element right before the input element. In case the parent element have more elements is prevents
         * the Div element to be inserted at the Bottom.
         */
        this.renderer.insertBefore(this.el.nativeElement.parentElement, this.readOnlyElement, this.el.nativeElement);
    }
    /**
     * Converts a value to a number. In case of NaN returns null.
     * @param formattedNumber a formatted string number
     * @private
     */
    convertToNumber(formattedNumber) {
        const number = Number.parseFloat(formattedNumber);
        return isNaN(number) ? null : number;
    }
}
/** @nocollapse */ UxCleaveDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxCleaveDirective, deps: [{ token: i0.ElementRef }, { token: LOCALE_ID }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ UxCleaveDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: UxCleaveDirective, selector: "[uxCleave]", inputs: { options: ["uxCleave", "options"], readOnly: "readOnly", isModelNumber: "isModelNumber" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef((() => UxCleaveDirective)),
            multi: true
        }
    ], usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxCleaveDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[uxCleave]',
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => UxCleaveDirective)),
                            multi: true
                        }
                    ]
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [LOCALE_ID]
                }] }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }]; }, propDecorators: { options: [{
                type: Input,
                args: ['uxCleave']
            }], readOnly: [{
                type: Input
            }], isModelNumber: [{
                type: Input
            }] } });
class UxCleaveModule {
}
/** @nocollapse */ UxCleaveModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxCleaveModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxCleaveModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxCleaveModule, declarations: [UxCleaveDirective], imports: [CommonModule], exports: [UxCleaveDirective] });
/** @nocollapse */ UxCleaveModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxCleaveModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxCleaveModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [UxCleaveDirective],
                    declarations: [UxCleaveDirective]
                }]
        }] });

/* eslint-disable */
class UxTemplateDirective {
    constructor(template) {
        this.template = template;
    }
    getType() {
        return this.name;
    }
}
/** @nocollapse */ UxTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ UxTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: UxTemplateDirective, selector: "[uxTemplate]", inputs: { type: "type", name: ["uxTemplate", "name"] }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[uxTemplate]'
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; }, propDecorators: { type: [{
                type: Input
            }], name: [{
                type: Input,
                args: ['uxTemplate']
            }] } });
/* eslint-enable */
class UxTemplateDirectiveModule {
}
/** @nocollapse */ UxTemplateDirectiveModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxTemplateDirectiveModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxTemplateDirectiveModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxTemplateDirectiveModule, declarations: [UxTemplateDirective], imports: [CommonModule], exports: [UxTemplateDirective] });
/** @nocollapse */ UxTemplateDirectiveModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxTemplateDirectiveModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxTemplateDirectiveModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [UxTemplateDirective],
                    declarations: [UxTemplateDirective]
                }]
        }] });

/* eslint-disable */
class NguiAutoCompleteDropdownButtonDirective {
    constructor(el) {
        this.el = el;
        this._hasDropdownButton = false;
    }
    get hasDropdownButton() { return this._hasDropdownButton; }
    set hasDropdownButton(value) { this._hasDropdownButton = coerceBooleanProperty(value); }
    ngAfterViewInit() {
        if (this.hasDropdownButton) {
            const input = this.el.nativeElement;
            if (input && input.offsetParent) {
                this.inputParent = input.offsetParent;
                this.inputButton = document.createElement('div');
                this.inputButton.className = 'ngui-auto-complete-wrapper__button';
                input.style.paddingRight = '2rem';
                this.inputButton.addEventListener('click', this.onClickListener.bind(this));
                this.inputParent.appendChild(this.inputButton);
            }
        }
    }
    onClickListener() {
        this.el.nativeElement.focus();
    }
    ngOnDestroy() {
        if (this.inputButton) {
            this.inputButton.removeEventListener('click', this.onClickListener);
            this.inputButton.remove();
        }
    }
}
/** @nocollapse */ NguiAutoCompleteDropdownButtonDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: NguiAutoCompleteDropdownButtonDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ NguiAutoCompleteDropdownButtonDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: NguiAutoCompleteDropdownButtonDirective, selector: "input[ngui-auto-complete]", inputs: { hasDropdownButton: "hasDropdownButton" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: NguiAutoCompleteDropdownButtonDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[ngui-auto-complete]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { hasDropdownButton: [{
                type: Input
            }] } });
class NguiAutoCompleteDropdownButtonModule {
}
/** @nocollapse */ NguiAutoCompleteDropdownButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: NguiAutoCompleteDropdownButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ NguiAutoCompleteDropdownButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: NguiAutoCompleteDropdownButtonModule, declarations: [NguiAutoCompleteDropdownButtonDirective], imports: [CommonModule], exports: [NguiAutoCompleteDropdownButtonDirective] });
/** @nocollapse */ NguiAutoCompleteDropdownButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: NguiAutoCompleteDropdownButtonModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: NguiAutoCompleteDropdownButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [NguiAutoCompleteDropdownButtonDirective],
                    declarations: [NguiAutoCompleteDropdownButtonDirective]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { NguiAutoCompleteDropdownButtonDirective, NguiAutoCompleteDropdownButtonModule, UxAutoResizeDirective, UxAutoResizeModule, UxCleaveDirective, UxCleaveModule, UxCollapsibleDirective, UxCollapsibleDirectiveModule, UxHasPermissionDirective, UxHasPermissionDirectiveModule, UxMaxlengthDirective, UxMaxlengthModule, UxScrollHandlerDirective, UxScrollHandlerDirectiveModule, UxScrollHandlerElementDirective, UxSmoothScrollDirective, UxSmoothScrollDirectiveModule, UxSmoothScrollToDirective, UxTemplateDirective, UxTemplateDirectiveModule, UxTooltipDirective, UxTooltipModule };
